var map = {
	"./CN.png": [
		1147,
		4
	],
	"./ID.png": [
		1148,
		5
	],
	"./MY.png": [
		1149,
		6
	],
	"./SG.png": [
		1150,
		7
	],
	"./TH.png": [
		1151,
		8
	],
	"./US.png": [
		1152,
		9
	],
	"./VN.png": [
		1153,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 229;
module.exports = webpackAsyncContext;